import { noop } from '@openx/utils/noop';
import { createContext } from 'react';
import type { ConfigContextValue } from './types';

export const configContext = createContext<ConfigContextValue>({
  registerLocalErrorHandler: () => {
    noop();
  },
  unregisterLocalErrorHandler: () => {
    noop();
  },
});
